export const formateEphochDate = {
  data() {
    return {};
  },
  methods: {
    formateEphochDateMethod(epoch) {
      const date = new Date(epoch);
      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const year = date.getUTCFullYear();
      return `${day}-${month}-${year}`;
    },
  },
};
